import { render, staticRenderFns } from "./TgAmountBar.vue?vue&type=template&id=fb23a5d8"
import script from "./TgAmountBar.vue?vue&type=script&lang=js"
export * from "./TgAmountBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports